export default __webpack_public_path__ + "static/media/afternoon-icon.ec54c643.svg";